export function nextMonth(date) {
  return date.clone().add(1, 'M');
}
export function prevMonth(date) {
  return date.clone().subtract(1, 'M');
}
